/**
 * PeopleHub allows sorting of the list in a number of ways. Sorting governs the order in which names are displayed in the list, as well as the
 * category under which a set of contacts fall.
 * Copied from https://outlookweb.visualstudio.com/Outlook%20Web/_git/client-web?path=%2Fpackages%2Fapps%2Fpeople%2Fappstate%2Flib%2Fstate%2Fview%2FlayoutState.ts
 */
enum Sorting {
    ByFirstName,
    ByLastName,
    ByStatus,
    ByHomeCity,
    ByWorkCity,
    ByCompany,
    ByLastChanged,
    ByRelevance,
    ByRecentlyAdded,
    ByName,
    ByDeletedDate,
}

export default Sorting;
